import { render } from "./contact-scr.vue?vue&type=template&id=068a1692&scoped=true"
import script from "./contact-scr.vue?vue&type=script&lang=js"
export * from "./contact-scr.vue?vue&type=script&lang=js"

import "./contact-scr.vue?vue&type=style&index=0&id=068a1692&scoped=true&lang=css"

import exportComponent from "/Users/achinthaprabasha/Desktop/work/yathra/yathra-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-068a1692"]])

export default __exports__